module.exports = __webpack_public_path__ + "public/img/C2QB_green_btn_med_default.1265dfb0.png";